import { ItemComponentBase, ItemResultRenderTarget, ItemResultRenderTargetComponents } from 'products-ui';

export abstract class WireCutItemResultLayoutComponentsProviderComponentBase extends ItemComponentBase {
  protected readonly LayoutTargets = ItemResultRenderTarget;
  protected readonly LayoutComponents = ItemResultRenderTargetComponents;
  // protected readonly productDetailStore = inject(WireCutItem);

  constructor() {
    super();
    // effect(() => {
    //   this.productDetailStore.selectById(this.productId());
    // });
  }
}
